export default __webpack_public_path__ + "static/media/imone-icon.4ccfc41d.svg";